import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

import LangTab from "../../../components/tabs/langTab";
import {showLoader} from "../../../components/loader/loader";
import {langService} from "../../../jwt/_services";
import {FL_LONG_NAME, FL_SHORT_NAME} from "../../../components/i18n/formLabels";
import {PH_LONG_NAME, PH_SHORT_NAME} from "../../../components/i18n/placeHolders";


class XailingRoutLangs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            editMode: this.props.editMode,
            disableInputs : this.props.disableInputs,
            xailingRout : this.props.xailingRout,
            langChilds: [],
            langXailingRoutChilds: this.props.editMode ? this.props.xailingRout?.langs : []
        }

        this.setForm = this.setForm.bind(this);
        this.combineLangChilds = this.combineLangChilds.bind(this);
        this.getLangChilds = this.getLangChilds.bind(this);
        this.getFormulary = this.getFormulary.bind(this);
        this.updateParent = this.updateParent.bind(this);
        this.onNameChange = this.onNameChange.bind(this);
        this.onLongNameChange = this.onLongNameChange.bind(this);
    }

    // ----------------------------------
    // Establece las opciones de idioma
    // ----------------------------------
    componentDidMount() {
        let langChilds = [];
        this.setState({loading: true});

        langService.getAll().then(langOptions => {
            if (langOptions) {
                langOptions.map((lang, _) => {
                    const langChild = {
                        id: '',
                        lang: lang,
                        name: '',
                        longName: '',
                    };
                    langChilds.push(langChild);
                    this.setState({langChilds, loading: false});
                });
            }
        })
            .then( () => {
                if (this.state.editMode){
                    langChilds = this.combineLangChilds(this.state.langChilds, this.state.langXailingRoutChilds);
                    this.setState({ langChilds });
                }
            }).finally(()=>this.setState({loading: false}));
    }

    setForm(editMode, showList, data) {
        this.props.setForm(editMode, showList, data)
    }

    getLangChilds(){
        const langChilds = this.combineLangChilds(this.state?.langChilds, this.state?.langXailingRoutChilds);
        return (langChilds ? langChilds : (this.state?.langChilds ? this.state?.langChilds : []));
    }

    changeDisabledInput(option, langs){
        this.setState({disableInputs:option, langXailingRoutChilds:langs });
        this.getLangChilds(); // Refresh component
    }

    resetForm(){
        let langOption = [];
        this.state.langChilds.map((langC) => {
            const langChild = {
                id: '',
                lang: langC.lang,
                name: '',
                longName: '',
            };
            langOption.push(langChild);
        });
        this.setState({langChilds: langOption, langXailingRoutChilds: [], disableInputs : false});
        this.getLangChilds();
    }

    combineLangChilds(langOptions, langXailingRoutChilds){
        try {
            if (langOptions && langXailingRoutChilds && langOptions.length > 0 && langXailingRoutChilds.length > 0){
                langOptions.map((child, index) => {
                    const langTagIndex = langXailingRoutChilds.findIndex(n => n.lang === child.lang.id);

                    if (langTagIndex !== -1) {
                        // significa que si lo encontro
                        langOptions[index] = {
                            id :    langXailingRoutChilds[langTagIndex].id,
                            lang :  child.lang,
                            name :  langXailingRoutChilds[langTagIndex].name,
                            longName :  langXailingRoutChilds[langTagIndex].longName,
                        }
                    }
                });
                return langOptions;
            }
        } catch (e) {
            return e.message;
        }
    }

    // Le envia la información al componente padre
    updateParent(langChilds){
        this.props.updateItem(langChilds);
        this.setState({
            langChilds : langChilds,
            langXailingRoutChilds : langChilds
        });
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    onNameChange(value, index, lang){
        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);
        let langChilds = this.state.langChilds.slice();

        if(langIndex === -1)
            return;

        langChilds[langIndex] = {
            lang : langChilds[langIndex].lang,
            id : langChilds[langIndex].id,
            name :  value,
            longName :  langChilds[langIndex].longName,
        }

        this.updateParent(langChilds);
    }

    onLongNameChange(value, index, lang){
        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);
        let langChilds = this.state.langChilds.slice();

        if(langIndex === -1)
            return;

        langChilds[langIndex] = {
            lang : langChilds[langIndex].lang,
            id : langChilds[langIndex].id,
            name :  langChilds[langIndex].name,
            longName :  value,
        }

        this.updateParent(langChilds);
    }

    getFormulary(child, index, disableInputs){
        return (<>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label>{ FL_SHORT_NAME }</Label>
                        <Input
                            type="text"
                            name="name"
                            placeholder={ PH_SHORT_NAME }
                            value= { child.name }
                            onChange={e => this.onNameChange(e.target.value, index, child.lang )}
                            disabled={disableInputs}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label>{ FL_LONG_NAME }</Label>
                        <Input
                            type="text"
                            name="longName"
                            placeholder={ PH_LONG_NAME }
                            value= { child.longName }
                            onChange={e => this.onLongNameChange(e.target.value, index, child.lang )}
                            disabled={disableInputs}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </>);
    }

    render() {
        return (
            <Row>
                {this.state.loading ? showLoader() : null}
                <Col md="12">
                    <LangTab
                        key={"LangId"}
                        langChilds={this.state.langChilds}
                        getLangChilds={this.getLangChilds}
                        getFormulary={this.getFormulary}
                        disableInputs={this.state.disableInputs}
                    />
                </Col>
            </Row>
        );
    }
}

export default XailingRoutLangs;